import { getTemplateCategoryId, TEMPLATE_CATEGORY } from "../channels/global/whatsapp/templates/utils"

export const defaultNoneTag = {
    contact_tag_id: -1,
    contact_tag_name: "None",
    created_at_timestamp: "",
    updated_at_timestamp: "",
}

export const defaultCreateTemplatePayload = (templateCategoryList = []) => ({
    "whatsapp_template_id": null,
    "meta_integration_whatsapp_id": 1,
    "whatsapp_template_type_id": 0,
    whatsapp_template_flag_interactive_message: false, 
    "whatsapp_template_flag_flow": false,
    "interactive_type_id": null, 
    "interactive_list_button_text": null,
    "flag_named_parameter": false,
    "whatsapp_template_data": {
        "whatsapp_template_data_id": null,
        "whatsapp_template_category_id": getTemplateCategoryId(TEMPLATE_CATEGORY?.UTILITY, templateCategoryList ?? []),
        "whatsapp_language_id": 0,
        "whatsapp_template_name": "",
        "whatsapp_template_description": "",
        "whatsapp_template_header": {
            "whatsapp_template_header_type_id": "",
            "whatsapp_template_header_type_name": "",
            "whatsapp_template_header_data": [
                {
                    "whatsapp_template_header_data_value": "",
                    "whatsapp_template_header_data_id": 0,
                    "whatsapp_template_header_data_google_storage_id": 0,
                    "whatsapp_template_header_variable_data": []
                }
            ]
        },
        "whatsapp_template_body": {
            "whatsapp_template_body_value": "",
            "whatsapp_template_body_description": "",
            "whatsapp_template_body_variable_data": []
        },
        "whatsapp_template_button": [],
        "whatsapp_template_footer": {
            "whatsapp_template_footer_id": "",
            "whatsapp_template_footer_value": ""
        },
        "whatsapp_template_carousel": {
            "whatsapp_template_carousel_header": "",
            "whatsapp_template_carousel_header_dynamic_variable": [],
            "whatsapp_template_carousel_card": []
        }
    }
})